
import { useEffect, useState } from 'react';

import EReceiptRow from 'component/e-invoice/EReceiptRow';
import NoData from 'component/NoData';

const EReceiptSelection = ({items, filter, onSend}) =>
{
  const [refresh, onRefresh  ] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    setFilteredItems(getFilteredBills());
  }, [items, filter]);

  const forceRefresh = () => {
    onRefresh(!refresh);
  }

  const getFilteredBills = () =>
  {
    return items.filter(item => {
      if (filter.company && filter.company != item.company) return false;
      if (Number.isInteger(filter.location)) {
        let locs = item.arr_loc.filter(loc => filter.district == loc.mgt && filter.location == loc.loc);
        if (locs.length <= 0) return false;
      } else if (filter.district) {
        if (item.arr_loc.map(loc => loc.mgt).indexOf(filter.district) < 0) return false;
      }
      if (filter.cd_license && !String(item.license).toUpperCase().includes(String(filter.cd_license).toUpperCase())) return false;
      if (filter.media_type && !item['is_'+filter.media_type]) return false;
      return true;
    });
  }

  const selectAllFiltered = (e) => {
    getFilteredBills().forEach(item => {
      item.selected = !!e.target.checked;
    });
    forceRefresh();
  }

  const selectedCount = () => {
    return items.reduce((r,x) => r + (x.selected?1:0), 0);
  }

  const isAllFilteredSelected = () => {
    for (let item of filteredItems) {
      if (!item.selected) {
        return false;
      }
    }
    return true;
  }

  return (<div className="box e-invoice-selection">
    <h4 className="box-head">已選擇：{selectedCount()}</h4>
    <div className="box-body">
      { filteredItems?.length <= 0
      ? <NoData />
      : <table className="data-table">
          <colgroup>
            <col width="auto" id="col-einv-checkbox" />
            <col width="auto" id="col-einv-company" />
            <col width="auto" id="col-einv-location" />
            <col width="auto" id="col-einv-license" />
            <col width="auto" id="col-einv-type" />
            <col width="auto" id="col-einv-transfer-date" />
            <col width="auto" id="col-einv-amount" />
            <col width="auto" id="col-einv-btn-email" />
            <col width="auto" id="col-einv-btn-whatsapp" />
          </colgroup>
          <thead>
            <tr>
              <th className="col-einv-checkbox">
                <input type="checkbox" checked={isAllFilteredSelected()}
                  onChange={selectAllFiltered}
                />
              </th>
              <th className="col-einv-company">公司</th>
              <th className="col-einv-location">地點</th>
              <th className="col-einv-license">車牌</th>
              <th className="col-einv-type">類型</th>
              <td className="col-einv-transfer-date">轉賬日期</td>
              <td className="col-einv-amount">金額</td>
              <th className="col-einv-btn-email"></th>
              <th className="col-einv-btn-whatsapp"></th>
            </tr>
          </thead>
          <tbody>
            { filteredItems.map(item =>
              <EReceiptRow key={item.id}
                item={item} onChange={forceRefresh} onSend={onSend} />
            )}
          </tbody>
        </table>
      }
    </div>
  </div>);
}

export default EReceiptSelection;
